

module.exports = __webpack_require__.stylable.create(
    "Quantity2758862235",
    {"classes":{"root":"Quantity2758862235__root","rootHalfWidth":"Quantity2758862235__rootHalfWidth","rootSmall":"Quantity2758862235__rootSmall"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    14,
    "Quantity2758862235",
    null
);
